import React from "react";
import Fade from "react-reveal/Fade";
import { NavLink } from "react-router-dom";
import { ProductItemsSkeleton } from "../user/ParcoursAchat/ParcoursAchat";
import { BestSellerCard } from "./BestSellerCard";

interface ProductsSectionProps {
  title: string;
  products: any[];
  isLoading?: boolean;
  showViewMore?: boolean;
  viewMoreText?: string;
  viewMoreLink?: string;
}

/**
 * Section de produits réutilisable avec le même design que BestSellersSection
 * - 4 cartes par ligne sur desktop
 * - 2 cartes par ligne sur mobile
 * - Utilise BestSellerCard pour un design identique
 */
export const ProductsSection: React.FC<ProductsSectionProps> = ({
  title,
  products,
  isLoading = false,
  showViewMore = true,
  viewMoreText = "Voir plus",
  viewMoreLink = "/produits",
}) => {
  if (!isLoading && (!products || products.length === 0)) {
    return null;
  }

  return (
    <div className="best-sellers-section">
      <div className="best-sellers-section-container">
        {/* Titre de la section */}
        <div className="best-sellers-section-header">
          <Fade bottom>
            <h3 className="best-sellers-section-title">
              {title}
            </h3>
          </Fade>
        </div>

        {/* Grille de cartes - Même design que BestSellersSection */}
        <div className="best-sellers-section-grid">
          {isLoading && <ProductItemsSkeleton />}
          {!isLoading &&
            products.map((produit, key) => (
              <div key={produit?.id || key} className="best-sellers-section-grid-item">
                <BestSellerCard item={produit} />
              </div>
            ))}
        </div>

        {/* Texte "Voir plus" aligné à droite */}
        {showViewMore && !isLoading && (
          <div className="best-sellers-section-footer">
            <Fade right>
              <NavLink to={viewMoreLink} className="best-sellers-section-button">
                {viewMoreText}
              </NavLink>
            </Fade>
          </div>
        )}
      </div>
    </div>
  );
};
